import {FC} from 'react'
import {split} from 'lodash'
import {Close} from 'jbc-front/components/icons'
import Loading from 'components/Loading'
import {PrepareCsvProcedureRequest, CONFIRM_PREPARE_CSV_PROCEDURE_REQUEST} from '../query'
import styles from './PrepareCsvProcedureAsyncStatus.scss'

// @ts-ignore
import {recordDisplay} from 'utils'
// @ts-ignore
import {useMutation} from 'components/Graphql'

const asyncStatusTitle = (prepareCsvProcedureRequest: PrepareCsvProcedureRequest) => {
  switch (prepareCsvProcedureRequest.status) {
    case 'waiting':
    case 'in_progress':
      return 'エラーチェックをしています...'
    case 'success':
      return '電子申請の準備が完了しました。「電子申請一覧」画面より確認してください。'
    case 'failed':
      return '電子申請の準備中にエラーが発生しました。'
  }
}

interface PrepareCsvProcedureAsyncStatusProps {
  prepareCsvProcedureRequest: PrepareCsvProcedureRequest
}

export const PrepareCsvProcedureAsyncStatus: FC<PrepareCsvProcedureAsyncStatusProps> = ({
  prepareCsvProcedureRequest,
}) => {
  const [confirmPrepareCsvProcedureRequest] = useMutation(CONFIRM_PREPARE_CSV_PROCEDURE_REQUEST)
  const handleClose = async () => {
    await confirmPrepareCsvProcedureRequest({variables: {id: prepareCsvProcedureRequest.id}})
  }

  switch (prepareCsvProcedureRequest.status) {
    case 'waiting':
    case 'in_progress':
      return (
        <div className={styles.asyncStatusInProgress}>
          <div className={styles.asyncStatusInProgressInner}>
            <div className={styles.asyncStatusLoading}>
              <Loading />
            </div>
            <p className={styles.asyncStatusInProgressTitle}>{asyncStatusTitle(prepareCsvProcedureRequest)}</p>
          </div>
        </div>
      )
    case 'success':
      return (
        <div className={styles.asyncStatusSuccess}>
          <div className={styles.asyncStatusInner}>
            <div className={styles.asyncStatusInfo}>
              <Close className={styles.asyncStatusClose} onClick={handleClose} />
              <p className={styles.asyncStatusTitle}>{asyncStatusTitle(prepareCsvProcedureRequest)}</p>
              <div className={styles.asyncStatusDates}>
                <dl>
                  <dt>開始日時：</dt>
                  <dd>{recordDisplay.date(prepareCsvProcedureRequest.startedAt, 'LLL')}</dd>
                </dl>
                <dl>
                  <dt>完了日時：</dt>
                  <dd>{recordDisplay.date(prepareCsvProcedureRequest.finishedAt, 'LLL')}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      )
    case 'failed':
      return (
        <div className={styles.asyncStatusError}>
          <div className={styles.asyncStatusInner}>
            <div className={styles.asyncStatusInfo}>
              <Close className={styles.asyncStatusClose} onClick={handleClose} />
              <p className={styles.asyncStatusTitle}>{asyncStatusTitle(prepareCsvProcedureRequest)}</p>
              <div className={styles.asyncStatusDates}>
                <dl>
                  <dt>開始日時：</dt>
                  <dd>{recordDisplay.date(prepareCsvProcedureRequest.startedAt, 'LLL')}</dd>
                </dl>
              </div>
              {split(prepareCsvProcedureRequest.error, '\n').map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </div>
          </div>
        </div>
      )
    default:
      return null
  }
}
